import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../services/api.service';
import { isPlatformBrowser } from '@angular/common';

interface ContactData {
  name: string;
  mail: string;
  subject: string;
  message: string;
}

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactComponent implements OnInit {
  isLoading = false;
  contactData: ContactData = {
    name: '',
    mail: '',
    subject: '',
    message: ''
  };
  
  contactResult: boolean | null = null;
  isSubmitting = false;

  constructor(
    private apiService: ApiService,
    private translateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    // Component initialization
  }

  async submitContact(): Promise<void> {
    if (!this.isValidForm()) {
      return;
    }

    try {
      this.isSubmitting = true;
      this.contactResult = null;

      const result = await this.apiService.contact(this.contactData).toPromise();
      
      if (result) {
        this.contactResult = true;
        this.resetForm();
      } else {
        this.contactResult = false;
      }
    } catch (error) {
      console.error('Contact form error:', error);
      this.contactResult = false;
    } finally {
      this.isSubmitting = false;
    }
  }

  private isValidForm(): boolean {
    return !!(
      this.contactData.name?.trim() &&
      this.contactData.mail?.trim() &&
      this.contactData.subject?.trim() &&
      this.contactData.message?.trim() &&
      this.isValidEmail(this.contactData.mail)
    );
  }

  private isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  private resetForm(): void {
    this.contactData = {
      name: '',
      mail: '',
      subject: '',
      message: ''
    };
  }

  onInputChange(field: keyof ContactData, value: string): void {
    this.contactData[field] = value;
    // Clear previous results when user starts typing
    if (this.contactResult !== null) {
      this.contactResult = null;
    }
  }

  getTranslatedText(key: string): string {
    return this.translateService.instant(key) || key;
  }
}
